// extracted by mini-css-extract-plugin
export default {"raceSelectWrapper":"raceSelectWrapper__WKF3C","raceSelectBackground":"raceSelectBackground__SPuz8","raceSelectSectionsWrapper":"raceSelectSectionsWrapper__rBcT_","raceSelectSection":"raceSelectSection__LeIzM","humans":"humans__SpKaL","elves":"elves__akbKK","raceSelectTitle":"raceSelectTitle__imny5","raceSelectCtaButton":"raceSelectCtaButton__PqoWO","raceSelectText":"raceSelectText__dI63E"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"raceSelectWrapper\":\"raceSelectWrapper__WKF3C\",\"raceSelectBackground\":\"raceSelectBackground__SPuz8\",\"raceSelectSectionsWrapper\":\"raceSelectSectionsWrapper__rBcT_\",\"raceSelectSection\":\"raceSelectSection__LeIzM\",\"humans\":\"humans__SpKaL\",\"elves\":\"elves__akbKK\",\"raceSelectTitle\":\"raceSelectTitle__imny5\",\"raceSelectCtaButton\":\"raceSelectCtaButton__PqoWO\",\"raceSelectText\":\"raceSelectText__dI63E\"}";
        // 1787130558064
        var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  